import { reactive, computed } from '@vue/composition-api';
import merge from 'lodash/merge';
import api, { options } from '@/api';

const offsetValue = 55;

const state = reactive({
    config: {
        dateFormat: {
            shortDate: 'dd MMM',
            date: 'yyyy/MM/dd',
            time: 'HH:mm',
            dateTime: 'yyyy/MM/dd HH:mm:ss',
        },
        general: {
            'system_name': 'Upyield',
            'locale': 'en',
            'tracking_host': '',
            'default_currency': 'EUR',
            'first_week_day': 1,
        },
        'register': { 'termsconditions_url': null, 'terms_conditions': { 'url': null, 'required': 0 } },
        'screenshot': { 'preview': 'lp/previews/', 'thumb': 'lp/thumbs/' },
        'publisher_api': { 'url': '' },
        ignoredErrorCodes: options.ignoredErrorCodes,
        loadingErrorCodes: options.loadingErrorCodes,
        messages: {
            info: {
                offset: offsetValue,
            },
            warning: {
                offset: offsetValue,
            },
            error: {
                duration: 6000,
                showClose: true,
                offset: offsetValue,
            },
            success: {
                duration: 2000,
                offset: offsetValue,
            },
            apiError: {
                type: 'error',
                message: 'Internal Server Error',
                duration: 6000,
                showClose: true,
                offset: offsetValue,
            },
            saveSuccess: {
                type: 'success',
                message: 'Saving was succesful',
                duration: 2000,
                offset: offsetValue,
            },
        },
    },
});

export default computed(() => state.config);

export function extend (newState) {
    merge(state.config, newState);
    state.config = { ...state.config };
}

export function getConfig () {
    return api.config.list().then(({ data }) => {
        const response = data.data;
        response.general.first_week_day = Number(response.general.first_week_day);
        response.apiVersion = data.meta.api_version;
        extend(response);
    });
}
